import { Component } from '@theme/component';

class LanoelCartWallets extends Component {
  #observer;
  #resizeObserver;
  #frame;

  connectedCallback() {
    super.connectedCallback();
    this.#resizeObserver = new ResizeObserver(() => this.#queueMeasure());
    this.#observer = new MutationObserver(() => this.#refresh());
    this.#observer.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['wallet-configs'] });
    this.#refresh();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#observer?.disconnect();
    this.#resizeObserver?.disconnect();
    cancelAnimationFrame(this.#frame);
  }

  #refresh() {
    this.#filterWallets();
    this.#resizeObserver?.disconnect();
    for (const checkout of this.querySelectorAll('shopify-accelerated-checkout-cart')) {
      this.#resizeObserver?.observe(checkout);
      for (const wallet of checkout.children) this.#resizeObserver?.observe(wallet);
    }
    this.#queueMeasure();
  }

  #queueMeasure() {
    cancelAnimationFrame(this.#frame);
    this.#frame = requestAnimationFrame(() => this.#trimReservedSpace());
  }

  #trimReservedSpace() {
    for (const checkout of this.querySelectorAll('shopify-accelerated-checkout-cart')) {
      const bounds = checkout.getBoundingClientRect();
      if (!bounds.width || !bounds.height) continue;
      const wallets = Array.from(checkout.children)
        .filter((wallet) => wallet.matches('shopify-paypal-button'))
        .map((wallet) => wallet.getBoundingClientRect())
        .filter((rect) => rect.width > 0 && rect.height > 0);
      if (!wallets.length) continue;
      const before = Math.max(0, Math.min(...wallets.map((rect) => rect.top)) - bounds.top);
      const after = Math.max(0, bounds.bottom - Math.max(...wallets.map((rect) => rect.bottom)));
      for (const [name, value] of [['--ln-wallet-space-before', before], ['--ln-wallet-space-after', after]]) {
        const pixels = value.toFixed(2) + 'px';
        if (checkout.style.getPropertyValue(name) !== pixels) checkout.style.setProperty(name, pixels);
      }
    }
  }

  #filterWallets() {
    for (const checkout of this.querySelectorAll('shopify-accelerated-checkout-cart')) {
      const configuration = checkout.getAttribute('wallet-configs');
      if (!configuration) continue;
      try {
        const wallets = JSON.parse(configuration);
        if (!Array.isArray(wallets)) continue;
        const supported = wallets.filter((wallet) => wallet.name === 'paypal');
        if (supported.length !== wallets.length) {
          const replacement = checkout.cloneNode(false);
          replacement.setAttribute('wallet-configs', JSON.stringify(supported));
          checkout.replaceWith(replacement);
        }
      } catch {
        continue;
      }
    }
  }
}

if (!customElements.get('lanoel-cart-wallets')) {
  customElements.define('lanoel-cart-wallets', LanoelCartWallets);
}

